.root {
  position: sticky;
  inset-block-end: 0;
  display: flex;
  flex-direction: column-reverse;
  gap: var(--space-3);
  padding-block: var(--space-4);
  background: var(--md-surface);
  z-index: var(--z-sticky);
}

.nonSticky {
  position: static;
}

.end {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

@media (--window-medium) {
  .root,
  .end {
    flex-direction: row;
    align-items: center;
  }

  .end {
    margin-inline-start: auto;
  }
}
